import type { Locale } from "date-fns";
import { enGB, enUS, es, fr, it } from "date-fns/locale";

/**
 * Maps i18n language codes (e.g. "en", "en-US", "it") to date-fns locales.
 * Replaces the global `moment.locale()` that used to be set in locales/index.ts —
 * date-fns has no global locale, so the locale is resolved per call instead.
 */
export const dateFnsLocales: Record<string, Locale> = {
  en: enGB,
  "en-GB": enGB,
  "en-US": enUS,
  it,
  "it-IT": it,
  fr,
  "fr-FR": fr,
  es,
  "es-ES": es,
};

export const getDateFnsLocale = (lng?: string | null): Locale => {
  if (!lng) return enGB;
  return dateFnsLocales[lng] ?? dateFnsLocales[lng.split("-")[0]] ?? enGB;
};
